import { render, staticRenderFns } from "./related_contracts.vue?vue&type=template&id=7dfbfc0a&scoped=true&"
import script from "./related_contracts.vue?vue&type=script&lang=js&"
export * from "./related_contracts.vue?vue&type=script&lang=js&"
import style0 from "./related_contracts.vue?vue&type=style&index=0&id=7dfbfc0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfbfc0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dfbfc0a')) {
      api.createRecord('7dfbfc0a', component.options)
    } else {
      api.reload('7dfbfc0a', component.options)
    }
    module.hot.accept("./related_contracts.vue?vue&type=template&id=7dfbfc0a&scoped=true&", function () {
      api.rerender('7dfbfc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/products_management/components/related_contracts.vue"
export default component.exports